<template>
  <div class="pageContainer">
    <div class="topTips">
      <span>{{ appName }}</span
      >将尽全力保护您的个人安全，并保障您在个人信息处理过程中的相关权益。为了向您提供<span
        >{{ appName }}</span
      >的基本功能及附加功能，我们需要收集您在使用服务时通过您主动授权/提供等方式产生的个人信息。以下我们将逐说明收集情况，方便您快速查阅。
    </div>
    <div class="menuList">
      <router-link to="/userInfo" class="menuItem">
        <div class="itemText">个人信息</div>
        <i class="itemIcon el-icon-arrow-right"></i>
      </router-link>
      <router-link to="/applyInfo" class="menuItem">
        <div class="itemText">使用信息</div>
        <i class="itemIcon el-icon-arrow-right"></i>
      </router-link>
      <router-link to="/deviceInfo" class="menuItem">
        <div class="itemText">设备信息</div>
        <i class="itemIcon el-icon-arrow-right"></i>
      </router-link>
    </div>
    <!-- <h4>personal info collect</h4>
    <h5>{{userId}}</h5>
    <h5 v-if="sdkVersion">{{sdkVersion}}</h5>
    <el-button @click="jumpPage('personInfo')">jumpPage('personInfo')</el-button>
    <el-button @click="jumpPage('orderRecord')">jumpPage('orderRecord')</el-button> -->
  </div>
</template>

<script>
import { getRequest } from "@/utils/common";
import {
  hasPrintmasterAuthParams,
  parsePrintmasterAuthQuery,
} from "@/constants/printmasterUrlAuth";
export default {
  data() {
    return {
      userId: "",
      sdkVersion: "",
      appName: "",
    };
  },
  mounted() {
    const query = this.$router.currentRoute.query;
    const {
      lang,
      platform,
      userId,
      sdkVersion,
    } = query;

    let isAndroid = false;
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("iphone") >= 0) {
      //
    } else if (ua.indexOf("android") >= 0) {
      isAndroid = true;
    } else {
      if (Android) {
        isAndroid = true;
      } else {
        //
      }
    }

    this.$store.commit("updateData", {
      lang,
      platform,
      userId,
      sdkVersion,
      isAndroid,
    });
    if (platform === "Printmaster") {
      if (hasPrintmasterAuthParams(query)) {
        this.$store.commit("updateData", {
          printmasterAuth: parsePrintmasterAuthQuery(query),
        });
      } else {
        this.$store.commit("updateData", { printmasterAuth: null });
      }
    }
    switch (platform) {
      case "Mrin":
        this.appName = "印先森";
        this.getInfo_Printmaster_Mrin(platform);
        break;
      case "Printmaster":
        this.appName = "小标打印";
        this.getInfo_Printmaster_LabelMaster(platform);
        break;
      case "LabelMaster":
        this.appName = "爱墨小标";
        this.getInfo_Printmaster_LabelMaster(platform);
        break;
      case "XBManager":
        this.appName = "小标管家";
        this.getInfo_Printmaster_LabelMaster(platform);
        break;
      case "Phocol":
        this.appName = "我们";
        this.getInfo_Printmaster_Phocol(platform);
        break;
      default:
        break;
    }
  },
  methods: {
    jumpPage(msg) {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf("iphone") >= 0) {
        window.webkit.messageHandlers.jumpPage.postMessage(msg);
      } else if (ua.indexOf("android") >= 0) {
        Android.jumpPage(msg);
      } else {
        if (Android && Android.jumpPage) {
          Android.jumpPage(msg);
        } else {
          window.webkit.messageHandlers.jumpPage.postMessage(msg);
        }
      }
    },
    getInfo_Printmaster_Mrin(platform) {
      const userId = this.$store.state.userId;
      if (userId) {
        getRequest(
          "/MrIn/user/v1/getUser",
          {
            userId,
          },
          {
            ua: "aa2ef6b9f2296f4",
            versionName: "Mrin",
            versionCode: "4.1.0",
            device: "iOS",
            lang: "zh-cn",
          }
        )
          .then((res) => {
            // console.log('getInfo res', res)
            if ((res.status === 200 || res.status === 2000) && res.data) {
              if (res.data.basics === "已收集") {
                res.data.basics = "基础信息";
              } else {
                res.data.basics = "基础信息";
              }
              const msg = {};
              msg[platform] = res.data;
              console.log({ msg });
              this.$store.commit("updateData", msg);
            }
          })
          .catch((err) => {
            console.log("getInfo err", err);
          });
      }
    },
    getInfo_Printmaster_LabelMaster(platform) {
      const userId = this.$store.state.userId;
      if (userId) {
        getRequest("/api/personalinfocollect/getInfo", {
          userId,
        })
          .then((res) => {
            // console.log('getInfo res', res)
            if (
              (res.status === 200 || res.status === 2000) &&
              res.data != null &&
              typeof res.data === "object" &&
              !Array.isArray(res.data)
            ) {
              const msg = {};
              msg[platform] = res.data;
              console.log({ msg });
              this.$store.commit("updateData", msg);
            }
          })
          .catch((err) => {
            console.log("getInfo err", err);
          });
      }
    },
    getInfo_Printmaster_Phocol(platform) {
      const userId = this.$store.state.userId;
      if (userId) {
        getRequest("/api/personalinfocollect/getInfo", {
          userId,
        })
          .then((res) => {
            // console.log('getInfo res', res)
            if (
              (res.code === 200 || res.code === 2000) &&
              res.data != null &&
              typeof res.data === "object" &&
              !Array.isArray(res.data)
            ) {
              const msg = {};
              msg[platform] = res.data;
              console.log({ msg });
              this.$store.commit("updateData", msg);
            }
          })
          .catch((err) => {
            console.log("getInfo err", err);
          });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.pageContainer
  padding .32rem .48rem
  box-sizing border-box
  .topTips
    font-size .28rem
    color #2F3541
    text-align justify
    line-height .4rem
  .menuList
    margin-top .32rem
    .menuItem
      display flex
      justify-content space-between
      align-items center
      height 1rem
      .itemText
        font-size .32rem
        color #2F3541
      .itemIcon
        font-size .32rem
        font-weight bold
        color #ABAEB3
</style>
